// Provider-agnostic payment launcher. Stripe → redirect; Razorpay → checkout popup + verify.
let rzpLoaded = false;

function loadRazorpay() {
  return new Promise((resolve) => {
    if (rzpLoaded && window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => { rzpLoaded = true; resolve(true); };
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

export async function payWithProvider(data, api, { onSuccess, onError } = {}) {
  if (data.provider === "stripe" || data.checkout_url) {
    window.location.href = data.checkout_url;
    return;
  }
  const ok = await loadRazorpay();
  if (!ok) { onError && onError("Could not load Razorpay. Check your connection."); return; }
  const rzp = new window.Razorpay({
    key: data.key_id,
    order_id: data.razorpay_order_id,
    amount: data.amount,
    currency: data.currency || "INR",
    name: data.name || "VIPER OWL",
    description: data.description || "",
    prefill: data.prefill || {},
    theme: { color: "#084734" },
    handler: async (resp) => {
      try {
        const { data: v } = await api.post("/payments/razorpay/verify", {
          razorpay_order_id: resp.razorpay_order_id,
          razorpay_payment_id: resp.razorpay_payment_id,
          razorpay_signature: resp.razorpay_signature,
        });
        onSuccess && onSuccess(v);
      } catch (e) {
        onError && onError("Payment verification failed. If money was debited, do not pay again — contact support.");
      }
    },
    modal: { ondismiss: () => onError && onError("Payment cancelled") },
  });
  rzp.on("payment.failed", () => onError && onError("Payment failed. Please try again."));
  rzp.open();
}
